import React from 'react'
import './nav_home.css'
import {AiOutlineHome} from 'react-icons/ai'
import { useState } from 'react'

const Nav = () => {
  const [activeNav,setActiveNav]=useState('')
  return (
    <nav>
      <a href='/'onClick={()=>setActiveNav('#')} className={activeNav==='#'?'active':''}><AiOutlineHome/></a>
    </nav>
  )
}

export default Nav